export default "__VITE_ASSET__PZ90lSa2__"